import React from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import Link from "@motorata/next.components.atoms.link";
import { NextImage } from "../common/Image";

const NotFoundProfilesBlock = () => {

  return (
    <>
      <Wrapper>
        <ImageWrapper>
          <Box width="100%" height="100%">
            <NextImage
              priority={true}
              fill
              objectFit="contain"
              objectPosition="bottom"
              alt="Grafika osoby poszukującej oferty"
              src="/images/not-found-profile-search.png"
            />
          </Box>
        </ImageWrapper>
        <TextWrapper>
          <Title elementType="label">
            Chcesz aby Twój komis znalazł się na naszej platformie?
          </Title>
          <P marginBottom="M">
            Zarejestruj się i dodaj swój komis samochodowy, aby zwiększyć zasięg ofert oraz
            rozpoznawalność marki!
          </P>
          <Link type="primary" width="max-content" href="https://panel.motorata.pl/register">
            Dołącz do nas
          </Link>
        </TextWrapper>
      </Wrapper>
    </>
  );
};

export default NotFoundProfilesBlock;

const TextWrapper = styled.div`
  padding: 3rem;
  flex: 1 1;
`;

const ImageWrapper = styled.div`
  width: 250px;
  position: relative;

  @media (max-width: 650px) {
    width: 100%;
    height: 200px;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    right: 0;
    top: 0;
    height: 100%;
    background: ${({ theme }) => theme.color.backgroundOpacity};
    clip-path: polygon(0 0, 50% 0, 100% 100%, 0% 100%);
    opacity: 0.2;

    @media (max-width: 650px) {
      right: auto;
      left: 0;
      top: auto;
      bottom: 0;
      clip-path: polygon(0 0, 100% 50%, 100% 100%, 0% 100%);
    }
  }
`;

const Wrapper = styled(Box)`
  background: white;
  display: flex;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  overflow: hidden;

  @media (max-width: 650px) {
    flex-direction: column-reverse;
  }
`;
